import PanelSales from '../panelsales/panelsales.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import ValueEnterprise from '../valueenterprise/valueEnterprise.vue'
import DetailsForm from '../detailsforms/detailsforms.vue'
import CommissionSales from '../commissionsales/commissionsales.vue'

const Tabs = {
  Detalhes: 0,
  valor: 1,
  comissao: 2
}

export default {
  components: {ValueEnterprise, DetailsForm, CommissionSales, PanelSales},
  props: ['selectedComissao'],
  name: 'DetailsSales',
  mixins: [ActionsForm],
  data () {
    return {
      headTable: ['Valor de parcela', 'Vencimento', 'status'],
      tabIndex: Tabs.Detalhes
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesinquiry/components/detailssales/detailssales.js